import { TooltipProps } from "recharts";
import { Stack } from "@altimateai/lego";
import { Typography } from "@altimateai/lego";
import dayjs from "dayjs";
import { formatCost } from "@/helpers/utils";
import { useAppState } from "@/modules/app/useAppContext";

export const CommonCostChartCustomTooltip = ({ payload }: TooltipProps<number, string>) => {
  const { currency } = useAppState();
  return (
    <Stack direction={"column"} className={"al-p-4 al-bg-white al-shadow al-rounded-md"}>
      <Typography variant={"subheading"} weight={"semibold"}>
        {payload?.[0]?.payload?.date ? dayjs(payload[0].payload.date).format("DD MMM YYYY") : ""}
      </Typography>
      <Stack align={"center"}>
        <div className={"al-size-3 al-bg-brand al-rounded"}></div>
        <span>
          Cost:{" "}
          {payload?.[0]?.payload?.cost ? formatCost(payload[0].payload.cost, currency) : "$0.00"}
        </span>
      </Stack>
    </Stack>
  );
};
